@if (resolvedDonneesChargees()) {
  <div class="body-content">
    <div class="section-kpi">

      <!-- ── Toolbar ─────────────────────────────────────────────────────────── -->
      <div class="section-kpi__toolbar">
        <app-input
          class="section-kpi__search"
          [placeholder]="'GLOBAL.RECHERCHER' | translate"
          [clearable]="true"
          [ngModel]="searchTerm()"
          (ngModelChange)="searchTerm.set($event)">
            <svg slot="icon-left" width="16" height="16">
                <use href="assets/icon/new_icon/search.svg"></use>
            </svg>
        </app-input>

        <div class="section-kpi__actions">
          @if (!estClient()) {
            <app-toggle
              [label]="'GLOBAL.VERIFIED' | translate"
              [checked]="kpiIsVerified()"
              (changed)="onVerifiedToggleChanged($event)">
            </app-toggle>

            @if (estTir()) {
              <app-button
                variant="tertiary"
                color="amarante"
                [addIconLeft]="true"
                [addLabel]="false"
                [title]="'KPI.RECALCULATE_KPIS' | translate"
                (clicked)="onRefresh()">
                <img slot="icon-left" src="assets/icon/new_icon/restore.svg" />
                <img slot="icon-left-active" src="assets/icon/new_icon/restore_active.svg" />
              </app-button>
            }
          }
        </div>
      </div>

      <hr class="section-kpi__separator">

      <!-- ── KPI list ────────────────────────────────────────────────────────── -->
      @if (!resolvedTabDonneesAnalyse() || resolvedTabDonneesAnalyse().length === 0) {
        <p class="section-kpi__empty">{{'DONNEE_ANALYSE.AUCUNE_DONNEE' | translate}}</p>
      }
      

      <app-data-table
        [data]="kpiTableRows()"
        [columns]="kpiTableColumns"
        rowKey="_id"
        [searchTerm]="searchTerm()"
        [clickable]="false"
        [equalColumns]="true"
        sortAscIcon="assets/icon/new_icon/arrow_full_down.svg"
        sortDescIcon="assets/icon/new_icon/arrow_full_up.svg"
        sortIconFilter="brightness(0)">

        <!-- Col 1 : Nom + description -->
        <ng-template tableCell="nom" let-row>
          <div class="kpi-row__info">
            <span class="kpi-row__name">{{ row.nom }}</span>
            @if (row.description) {
              <span class="kpi-row__desc">{{ row.description | translate }}</span>
            }
          </div>
        </ng-template>

        <!-- Col 2 : Type pill -->
        <ng-template tableCell="type" let-row>
          @if (row.type) {
            <span class="kpi-tag">{{ row.type }}</span>
          }
        </ng-template>

        <!-- Col 3 : Valeur finale (affichage / édition inline / toggle) -->
        <ng-template tableCell="finalValue" let-row>
          @if (row.typeSaisieKpi === 'InputText' || !estTir()) {
            @if (kpiEditId() !== row._id) {
              <!-- Mode affichage -->
              <div class="kpi-row__display-group">
                @if (row.finalValue) {
                  <span class="kpi-row__value">
                    {{ row.finalValue }} {{ replaceCurrencyPlaceholder(row.displayUnit) }}
                  </span>
                }
                @if (row.source && row.source !== 'SOURCE_KPI.NOT_SET' && row.autorisePourUtil) {
                  <span class="kpi-tag kpi-tag--italic">{{ row.source | translate }}</span>
                }
                @if (estTir()) {
                  <app-button *showIfHasRole="'access_all_kpi'"
                    class="kpi-row__edit-btn"
                    variant="tertiary"
                    color="amarante"
                    size="small"
                    [addIconLeft]="true"
                    [addLabel]="false"
                    (clicked)="onKpiEdit(row)">
                    <img slot="icon-left" src="assets/icon/edit-pencil.svg" alt="Modifier" />
                  </app-button>
                }
              </div>
            } @else {
              <!-- Mode édition inline -->
              <div class="kpi-row__edit-group">
                <app-input
                  class="kpi-row__edit-input"
                  size="small"
                  [(ngModel)]="kpiEditValue"
                  (keyup.enter)="onKpiValidate(row)"
                  [suffix]="replaceCurrencyPlaceholder(row.displayUnit)">
                </app-input>
                <app-button
                  variant="primary"
                  color="amarante"
                  size="small"
                  [addIconLeft]="true"
                  [addLabel]="false"
                  (clicked)="onKpiValidate(row)">
                  <img slot="icon-left" src="assets/icon/new_icon/check.svg" alt="Reset" />
                </app-button>
                <app-button
                  variant="tertiary"
                  color="amarante"
                  size="small"
                  [addIconLeft]="true"
                  [addLabel]="false"
                  [state]="!row._donnee.manualValue && !row._donnee.measuredValue ? 'disabled' : 'default'"
                  (clicked)="onKpiValidate(row, true)">
                  <img slot="icon-left" src="assets/icon/restore.png" alt="Reset" />
                </app-button>
              </div>
              @if (row.measuredValue) {
                <span class="kpi-row__measured">
                  {{ 'CONFIGURATION_DONNEES.MEASURED' | translate }}:
                  {{ displayMeasuredForEdit(row) }} {{ replaceCurrencyPlaceholder(row.displayUnit) }}
                </span>
              }
            }
          }
          @if (row.typeSaisieKpi === 'YesOrNo' && !estClient()) {
            <app-toggle
              color="mint"
              [checked]="row.finalValue === 'Oui'"
              (changed)="onKpiCheckboxChange($event, row)">
            </app-toggle>
          }
        </ng-template>

        <!-- Col 4 : Actions -->
        <ng-template tableCell="actions" let-row>
          <div class="kpi-row__actions">
            @if ((estTir() || estProjet()) && row.typeSaisieKpi === 'InputText') {
              <app-button *showIfHasRole="'access_all_kpi'"
                variant="secondary"
                color="amarante"
                size="small"
                [label]="'PRODUCTS.DETAILS' | translate"
                (clicked)="onKpiRowSelected(row)">
              </app-button>
            }
          </div>
        </ng-template>

      </app-data-table>

      <!-- ── Export CSV ──────────────────────────────────────────────────────── -->
      @if (typeParent() === TypeParent.Projet) {
        <div class="section-kpi__export">
          <app-button
            variant="secondary"
            color="amarante"
            [addIconLeft]="true"
            [label]="('GLOBAL.EXPORTER' | translate) + ' csv'"
            (clicked)="lancerExport()">
            <img slot="icon-left" src="assets/icon/new_icon/file-csv.svg" alt="" aria-hidden="true" />
          </app-button>
        </div>
      }

    </div>
  </div>
}

<!-- ── KPI detail popup ──────────────────────────────────────────────────────── -->
@if (kpiDetailDonnee()) {
  <app-popup
    [isOpen]="kpiDetailOpen()"
    [title]="'GLOBAL.DONNEES_ANALYSE' | translate"
    variant="secondary"
    color="mint"
    size="medium"
    (closed)="onKpiDetailClose()">

    <!-- Type + Nom -->
    <div class="kpi-detail__row">
      <div class="kpi-detail__col">
        <label class="kpi-detail__label kpi-detail__label--muted">{{ 'CONFIGURATION_DONNEES.TYPE' | translate }}</label>
        <app-input [ngModel]="kpiDetailTypeLabel()" [disabled]="true"></app-input>
      </div>
      <div class="kpi-detail__col">
        <label class="kpi-detail__label kpi-detail__label--muted">{{ 'GLOBAL.NOM' | translate }}</label>
        <app-input [ngModel]="kpiDetailDonnee()?.referentielDonneeAnalyse?.nom ?? ''" [disabled]="true"></app-input>
      </div>
    </div>

    <!-- Target value Site (read-only) -->
    <div class="kpi-detail__col">
      <label class="kpi-detail__label kpi-detail__label--muted">{{ 'CONFIGURATION_DONNEES.TARGET_VALUE' | translate }} Site</label>
      <app-input [ngModel]="kpiDetailCfg()?.valeurNominal?.toString() ?? ''" [disabled]="true"
        [suffix]="kpiDetailDisplayUnit()"></app-input>
    </div>

    <!-- Target value Blast (editable) -->
    <div class="kpi-detail__col">
      <label class="kpi-detail__label" [class.kpi-detail__label--muted]="!kpiDetailCanEdit()">
        {{ 'CONFIGURATION_DONNEES.TARGET_VALUE' | translate }} Blast
      </label>
      <app-input [ngModel]="kpiDetailValeurBlast()" (ngModelChange)="kpiDetailValeurBlast.set($event)"
        [disabled]="!kpiDetailCanEdit()" [suffix]="kpiDetailDisplayUnit()">
      </app-input>
      <app-button variant="secondary" color="amarante" size="small" [addIconLeft]="true"
        [label]="'GLOBAL.RESET' | translate"
        [state]="!kpiDetailCanEdit() ? 'disabled' : 'default'"
        (clicked)="kpiDetailValeurBlast.set(kpiDetailCfg()?.valeurNominal?.toString() ?? '')">
        <img slot="icon-left" src="assets/icon/restore.png" alt="" />
      </app-button>
    </div>

    <!-- Design (read-only) -->
    <div class="kpi-detail__col">
      <label class="kpi-detail__label kpi-detail__label--muted">{{ 'CONFIGURATION_DONNEES.DESIGN' | translate }}</label>
      <app-input [ngModel]="kpiDetailDonnee()?.designValue ?? ''" [disabled]="true"
        [suffix]="kpiDetailDisplayUnit()"></app-input>
    </div>

    <!-- Measured (read-only) -->
    <div class="kpi-detail__col">
      <label class="kpi-detail__label kpi-detail__label--muted">{{ 'CONFIGURATION_DONNEES.MEASURED' | translate }}</label>
      <app-input [ngModel]="kpiDetailDonnee()?.measuredValue ?? ''" [disabled]="true"
        [suffix]="kpiDetailDisplayUnit()"></app-input>
    </div>

    <!-- Manuel / As Blasted (editable) -->
    <div class="kpi-detail__col">
      <label class="kpi-detail__label" [class.kpi-detail__label--muted]="!kpiDetailCanEdit()">
        {{ 'CONFIGURATION_DONNEES.MANUEL' | translate }}
      </label>
      <app-input [ngModel]="kpiDetailValeurManuel()" (ngModelChange)="kpiDetailValeurManuel.set($event)"
        [disabled]="!kpiDetailCanEdit()" [suffix]="kpiDetailDisplayUnit()">
      </app-input>
      <app-button variant="secondary" color="amarante" size="small" [addIconLeft]="true"
        [label]="'GLOBAL.RESET' | translate"
        [state]="!kpiDetailCanEdit() ? 'disabled' : 'default'"
        (clicked)="kpiDetailValeurManuel.set('')">
        <img slot="icon-left" src="assets/icon/restore.png" alt="" />
      </app-button>
    </div>

    @if (kpiDetailErreurApi()) {
      <p class="kpi-detail__error">{{ 'GLOBAL.ERREUR_MAJ_API' | translate }}</p>
    }

    <div slot="footer">
      <div class="flex-gap-md" style="display: flex; gap: 1.5rem;">
        <app-button
          variant="secondary"
          color="mint"
          [label]="'GLOBAL.ANNULER' | translate"
          (clicked)="onKpiDetailClose()">
        </app-button>

        <app-button
          variant="primary"
          color="mint"
          [label]="'GLOBAL.CONFIRMER' | translate"
          [state]="!kpiDetailCanEdit() ? 'disabled' : 'default'"
          (clicked)="onKpiDetailSubmit()">
        </app-button>
      </div>
      
    </div>
  </app-popup>
}

<!-- ── KPI detail cancel confirmation popup ──────────────────────────────────── -->
<app-popup
  [isOpen]="kpiDetailCancelOpen()"
  [title]="'GLOBAL.CONFIRMATION_ANNULATION' | translate"
  variant="secondary"
  color="amarante"
  size="small"
  (closed)="kpiDetailCancelOpen.set(false)">

  <p>{{ 'GLOBAL.CONFIRMATION_ANNULATION' | translate }}</p>

  <div slot="footer">
    <app-button
      variant="primary"
      color="amarante"
      [label]="'GLOBAL.OUI' | translate"
      (clicked)="onKpiDetailConfirmCancel()">
    </app-button>
    <app-button
      variant="secondary"
      color="amarante"
      [label]="'GLOBAL.NON' | translate"
      (clicked)="kpiDetailCancelOpen.set(false)">
    </app-button>
  </div>
</app-popup>

<!-- ── Export popup ─────────────────────────────────────────────────────────── -->
<app-popup
  [isOpen]="exportModalOpen()"
  [title]="'GLOBAL.EXPORT_DONNEES' | translate"
  variant="tertiary"
  color="amarante"
  (closed)="exportModalOpen.set(false)">

  <p [class.section-kpi__popup-center]="!aucuneDonnee()">
    {{ aucuneDonnee() ? ('GLOBAL.AUCUNE_DONNEE_EXPORT' | translate) : ('GLOBAL.PREPARATION_EXPORT' | translate) }}
  </p>

  @if (aucuneDonnee()) {
    <div slot="footer">
      <app-button
        variant="secondary"
        color="amarante"
        [label]="'GLOBAL.FERMER' | translate"
        (clicked)="exportModalOpen.set(false)">
      </app-button>
    </div>
  }

</app-popup>


